const routes = [
    {
        path: "/school",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "school_index"
        }
    }
];

export default routes;